import { Button, Tooltip, makeStyles } from '@fluentui/react-components';
import { ArrowClockwise16Regular } from '@fluentui/react-icons';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles({
  button: {
    flexShrink: 0,
  },
});

interface PanelRefreshButtonProps {
  // Disabled while the panel's own fetch is in flight, so it can't be spammed.
  loading: boolean;
  onRefresh: () => void;
}

// Small in-panel refresh affordance: re-runs just this panel's data fetch.
const PanelRefreshButton = ({
  loading,
  onRefresh,
}: PanelRefreshButtonProps) => {
  const styles = useStyles();
  const { t } = useTranslation();
  return (
    <Tooltip content={t('refresh', 'Refresh')} relationship="label">
      <Button
        className={styles.button}
        size="small"
        appearance="subtle"
        icon={<ArrowClockwise16Regular />}
        disabled={loading}
        onClick={onRefresh}
        aria-label={t('refresh', 'Refresh')}
      />
    </Tooltip>
  );
};

export default PanelRefreshButton;
